<template>
  <div ref="printContainer" id="printContainer" class="grid-row-1 grid font-sans">
    <img ref="img" src="../../assets/header-revocatoria.jpg" alt="" class="bg-black" />
    <p class="my-2 text-right text-sm">Fecha de emisión: {{ fecha(new Date()) }}</p>
    <div class="space-y-2 text-center">
      <p class="font-bold text-colescba-blue-700">{{ title }}</p>
      <div v-if="notario.provincia.descripcion.toLowerCase().trim() === 'buenos aires'">
        <p class="px-20 font-bold">{{ notario.colegio.nombre }}</p>
      </div>
      <div v-else>
        <p class="px-20">
          Por convenio entre el <span class="font-bold">{{ notario.colegio.nombre }}</span>
        </p>
        <p class="px-20">y el Colegio de Escribanos de la Provincia de Buenos Aires</p>
      </div>
    </div>

    <p class="mt-6 font-bold">Constancia de solicitud #{{ solicitud.solicitudId }}</p>
    <div class="my-3 space-y-6">
      <!-- Datos del autorizante -->
      <div class="mt-3 space-y-1 text-sm">
        <p class="font-bold">
          {{
            solicitud.autorizantes.length > 1
              ? 'Datos de los autorizantes'
              : 'Datos del autorizante'
          }}
        </p>

        <div v-for="(autorizante, index) in solicitud.autorizantes" :key="index">
          <p class="font-bold" v-if="solicitud.autorizantes.length > 1">
            Autorizante {{ index + 1 }}
          </p>

          <ul class="ml-4 list-disc">
            <li>
              <span class="font-semibold">Nombre completo: </span>
              {{
                formatNombreCompleto(
                  autorizante.nombre,
                  autorizante.otrosNombres,
                  autorizante.apellido,
                  autorizante.segundoApellido,
                )
              }}
            </li>

            <li>
              <span class="font-semibold"> Vínculo: </span
              >{{ autorizante.caracterAutorizante.descripcion }}
            </li>

            <li>
              <span class="font-semibold">
                {{ capitalizarPrimeraLetra(autorizante.tipoDocumento.descripcion) }}:
              </span>
              {{ autorizante.numeroDocumento }}
            </li>
          </ul>
        </div>
      </div>

      <!-- Datos del menor -->
      <div class="mt-3 space-y-1 text-sm">
        <p class="font-bold">Datos del menor</p>
        <ul class="ml-4 list-disc">
          <li>
            <span class="font-semibold"> Nombre completo: </span>
            {{
              formatNombreCompleto(
                menor.nombre,
                menor.otrosNombres,
                menor.apellido,
                menor.segundoApellido,
              )
            }}
          </li>

          <li>
            <span class="font-semibold">
              {{ capitalizarPrimeraLetra(menor.tipoDocumento.descripcion) }}:
            </span>
            {{ menor.numeroDocumento }}
          </li>
        </ul>
      </div>

      <!-- Datos del escrinano autorizante -->
      <div class="mt-3 space-y-1 text-sm">
        <p class="font-bold">Datos del escribano autorizante</p>

        <ul class="ml-4 list-disc">
          <li>
            <span class="font-semibold">Nombre completo: </span> {{ capitalize(notario.nombres) }}
            {{ capitalize(notario.apellido) }}
          </li>

          <li><span class="font-semibold">Carnet: </span> {{ notario.carnet }}</li>
          <li>
            <span class="font-semibold">Provincia: </span> {{ notario.provincia.descripcion }}
          </li>
        </ul>
      </div>

      <!-- Detalle de la solicitud -->
      <div class="my-3 space-y-1 text-sm">
        <p class="font-bold">Historial de estados de la solicitud</p>
        <ul class="ml-4 list-disc">
          <li v-for="(estado, index) in solicitud.estadoHist" :key="index">
            <span
              class="font-medium"
              :class="{ 'text-gray-500': index != solicitud.estadoHist.length - 1 }"
            >
              {{ estado.descripcion }}
              <span class="text-gray-500"> - {{ fecha(estado.fechaCarga) }}</span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { useService } from '@colescba/app-vue'
import html2pdf from 'html2pdf.js'
import moment from 'moment'

export default {
  name: 'PrintSolicitud',

  mixins: [useService('reporteService')],

  props: {
    solicitud: { type: Object, required: true },
    notario: { type: Object, required: true },
    filename: { type: String, required: true },
    title: { type: String, required: true },
  },

  async mounted() {
    html2pdf(this.$refs.printContainer, {
      margin: 5,
      image: { type: 'jpeg', quality: 1.0 },
      filename: this.filename + ' .pdf',
      jsPDF: { format: 'a4' },
    })
  },

  computed: {
    menor() {
      return this.solicitud.menores[0]
    },

    estadoCreada() {
      return this.solicitud.estadoHist.find(s => s.estadoId == 'RTP')
    },

    estadoVerificada() {
      return this.solicitud.estadoHist.find(s => s.estadoId == 'RTV')
    },
  },

  methods: {
    capitalizarPrimeraLetra(str) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
    },

    capitalize(str) {
      return str.toUpperCase()
    },

    formatNombreCompleto(nombre, otroNombre, apellido, segundoApellido) {
      return (
        this.capitalize(nombre) +
        ' ' +
        this.capitalize(otroNombre) +
        ' ' +
        this.capitalize(apellido) +
        ' ' +
        this.capitalize(segundoApellido)
      )
    },

    fecha(date) {
      return moment(date).format('DD/MM/YYYY HH:mm')
    },
  },
}
</script>
